import { useEffect } from 'react';

const clearStuckModalBodyStyles = () => {
    if (document.body.classList.contains('modal-open')) {
        return;
    }

    document.body.style.removeProperty('padding-right');
    document.body.style.removeProperty('overflow');
};

/**
 * Reactstrap modals add body padding-right (~scrollbar width) while open.
 * That shows as a visible right-side gap and can remain stuck after close.
 * Disable the padding while open and clear inline styles once modals close.
 */
export const useModalBodyScrollFix = () => {
    useEffect(() => {
        clearStuckModalBodyStyles();

        const observer = new MutationObserver(() => {
            clearStuckModalBodyStyles();
        });

        observer.observe(document.body, {
            attributes: true,
            attributeFilter: ['class', 'style'],
        });

        return () => {
            observer.disconnect();
            clearStuckModalBodyStyles();
        };
    }, []);
};
